import React from 'react'

export default class AdvertisementView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			advertisement: null
		}
	}

	componentDidMount() {
		this.loadAdvertisement();
	}

	loadAdvertisement() {
		http.get('/home/loadAdvertisement.json', {alias: this.props.alias, random: this.props.random || 0}, response => {
			this.setState({advertisement: response.advertisement});
		})
	}

	render() {
		if (this.state.advertisement === null) {
			return null;
		}
		const advertisement = [];
		let group = [];
		const l = this.state.advertisement.length - 1;

		this.state.advertisement.forEach((adv, i) => {
			advertisement.push(
				<div key={i} className="col-sm-12 member mb-3">
					<a href={adv.href} target="_blank">
						<img src={adv.image} alt={adv.name} />
						<span>{adv.name.startsWith('#') ? null : adv.name}</span>
					</a>
				</div>
			);
			/*
			group.push(
				<div key={i} className={classNames("col ml-2 mb-2 member img-thumbnail", i % 2 == 1 ? 'mr-2' : null)}>
					<a href={adv.href} target="_blank">
						<img src={adv.image} className="img-fluid" alt={adv.name} />
					</a>
				</div>
			);
			if (i % 2 == 1 || i == l) {
				advertisement.push( <div key={i} className="row no-gutters">{group}</div> );
				group = [];
			}
			*/
		});
		return advertisement;
	}
}
